<template>
   <iframe :src="src" width="100%" height="100%"></iframe>
</template>
<script>
export default {
  data() {
    return {
      src: ''
    }
  },
  created() {
     this.src = this.$route.query.url
     console.log(this.$route)
  }
}
</script>
<style>
  iframe { position: static; border: none;}
</style>



// WEBPACK FOOTER //
// tab.vue?54f9bbf0